import dayjs from 'dayjs';
import relativeTime from "dayjs/plugin/relativeTime";
import {
    AngularLoadingSpinner,
    HighPriority,
    RefreshButton,
    ImmediatePriority,
    LowPriority,
    DefaultPriority,
    HistoryCrossButton,
    PendingSvg,
    ErrorSvg,
    UnknownSvg,
    PauseSvg,
    OngoingProgress,
    ErrorProgress,
    PauseProgress,
    UnknownProgress,
    PartialSvg,
    OnboardCompleteStatus,

} from "../Svgs";
import { ThreeDotsSvg } from "../Svgs"
import { useEffect, useRef, useState } from "react";
import ShimmerMenuList from "../../../../../CommonComponents/ShimmerEffectDesign/ShimmerMenu";
import useFiles from "../../../../hooks/useFiles";
import { formatFileSize } from "../../../../../../utils/commonFunctions";
import useContacts from "../../../../hooks/useContacts";
import PriorityModal from "../PriorityModal";
import useTrueTwin from "../../../../hooks/useTrueTwin";
import useUrlParams from '../../../../hooks/useUrlParams';
type Priority = "default" | "immediate" | "high" | "low";
type StatusGroup = "downloading" | "completed" | "planned" | "error";

interface FileType {
    status: string;
    filePriority?: string;
    band?: string;
    lastModified?: string;
    fileName?: string;
    uniqueId: string;
    fileSize?: number;
    progress?: number;
}

type CategorizedFiles = Record<StatusGroup, Record<Priority, FileType[]>>;
dayjs.extend(relativeTime);


const DownlinkQueue = ({ setTypeOfAction, setActionFileId, isReadOnlyActions = false }) => {
    const { tab_name } = useUrlParams()
    const [openThreeDots, setOpenThreeDots] = useState<any | null>(null);
    const menuRefs = useRef<Record<string, HTMLDivElement | null>>({});
    const [hover, setHover] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [viewHistory, setViewHistory] = useState(false)
    const [isRefreshIconEnable, setIsRefreshIconEnable] = useState(false)
    const [timeAgo, setTimeAgo] = useState('');
    const { truetwin_id } = useTrueTwin();
    const { contacts } = useContacts();
    const { ongoing_contacts } = contacts;
    const { allDownlinkingFiles, isDownlinkqueueLoading, getOnboardHistory, downlinkHistoryFiles, isRefreshTimeLoading, downlinkRefreshTime } = useFiles()
    const [categorizedFiles, setCategorizedFiles] = useState<CategorizedFiles>({
        downloading: { default: [], immediate: [], high: [], low: [] },
        completed: { default: [], immediate: [], high: [], low: [] },
        planned: { default: [], immediate: [], high: [], low: [] },
        error: { default: [], immediate: [], high: [], low: [] },
    });

    //EMPTY FILES
    const getEmptyCategorizedFiles = (): CategorizedFiles => ({
        downloading: { default: [], immediate: [], high: [], low: [] },
        completed: { default: [], immediate: [], high: [], low: [] },
        planned: { default: [], immediate: [], high: [], low: [] },
        error: { default: [], immediate: [], high: [], low: [] },
    });

    // HANDLE ENABLING OF REFRESH ICON BASED ON ACTIVE CONTACT
    useEffect(() => {
        if (!ongoing_contacts || ongoing_contacts.length === 0) {
            setIsRefreshIconEnable(false)
        } else {
            setIsRefreshIconEnable(true)
        }
    }, [ongoing_contacts])

    //CATEGORISED FILES BASED ON THE PRIORITY AND STATUS FOR QUEUE
    useEffect(() => {
        if (!allDownlinkingFiles) {
            setCategorizedFiles(getEmptyCategorizedFiles());
            return;
        }

        const filesArray = Array.from(allDownlinkingFiles.values());
        const grouped: CategorizedFiles = getEmptyCategorizedFiles();

        filesArray.forEach((file) => {
            let statusGroup: StatusGroup | null = null;

            switch (file.status) {
                case "download_inprogress":
                case "download_suspend":
                    statusGroup = "downloading";
                    break;
                case "download_success":
                    statusGroup = "completed";
                    break;
                case "download_pending":
                case "Pending":
                    statusGroup = "planned";
                    break;
                case "Error":
                    statusGroup = "error";
                    break;
                default:
                    break;
            }

            if (statusGroup) {
                let priority;
                if (file.filePriority === 'FILE_DL_PRIORITY_LOW') {
                    priority = 'low';
                } else if (file.filePriority === 'FILE_DL_PRIORITY_NORMAL') {
                    priority = 'default';
                } else if (file.filePriority === 'FILE_DL_PRIORITY_HIGH') {
                    priority = 'high';
                } else if (file.filePriority === 'FILE_DL_PRIORITY_IMMEDIATE') {
                    priority = 'immediate';
                } else {
                    priority = 'default';
                }

                grouped[statusGroup][priority].push(file);
            }
        });

        setCategorizedFiles(grouped);
    }, [allDownlinkingFiles]);

    //THREE DOTS MENU OPEN AND CLOSE
    const handleThreeDotsMenu = (e, file: any, type) => {
        if (isReadOnlyActions) return;
        e.stopPropagation();
        setOpenThreeDots(prev => (prev?.uniqueId === file?.uniqueId ? null : file));
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        if (type === 'plan') {
            if (tab_name === 'files-ground-files') {
                setMenuPosition({ top: rect.bottom + window.scrollY - 100 + 19 + 69 - 15 - 70, left: rect.right - 120 + window.scrollX - 23 });
            } else {
                setMenuPosition({ top: rect.bottom + window.scrollY - 100 + 19 + 69 - 15, left: rect.right - 120 + window.scrollX - 23 });
            }
        } else {
            if (tab_name === 'files-ground-files') {
                setMenuPosition({ top: rect.bottom + window.scrollY - 100 + 19 + 69 - 17 - 70, left: rect.right - 120 + window.scrollX - 23 + 44 });
            } else {
                setMenuPosition({ top: rect.bottom + window.scrollY - 100 + 19 + 69 - 17, left: rect.right - 120 + window.scrollX - 23 + 44 });
            }
        }
    }

    //CLOSE POPUP ON SCROLL
    useEffect(() => {
        const containers = document.querySelectorAll('.queue-planned-rows-body');

        const handleScroll = () => {
            if (openThreeDots) setOpenThreeDots(null);
        };

        containers.forEach(container => {
            container.addEventListener('scroll', handleScroll);
        });

        return () => {
            containers.forEach(container => {
                container.removeEventListener('scroll', handleScroll);
            });
        };
    }, [openThreeDots]);

    // HANDLE THREE DOTS MENU OPENING AND CLOSING
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            const threeDotsButtonOngoing = document.querySelectorAll('.right-buttons-container-ongoing');
            const threeDotsButtonPlanned = document.querySelectorAll('.right-buttons-container-planned');
            for (let i = 0; i < threeDotsButtonOngoing.length; i++) {
                if (threeDotsButtonOngoing[i].contains(e.target as Node)) {
                    return; // Clicked inside any of the menus
                }
            }
            for (let i = 0; i < threeDotsButtonPlanned.length; i++) {
                if (threeDotsButtonPlanned[i].contains(e.target as Node)) {
                    return; // Clicked inside any of the menus
                }
            }
            if (!openThreeDots) return; //if already close then return
            const menu = openThreeDots !== null ? menuRefs.current[openThreeDots?.uniqueId] : null;
            const target = e.target as Node;
            if (menu && !menu.contains(target)) {
                setOpenThreeDots(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openThreeDots]);

    //GET ICON BASED ON PRIORITY
    const priorityIcon = (priority) => {
        if (priority === 'FILE_DL_PRIORITY_HIGH') {
            return <HighPriority />
        } else if (priority === 'FILE_DL_PRIORITY_IMMEDIATE') {
            return <ImmediatePriority />
        } else if (priority === 'FILE_DL_PRIORITY_LOW') {
            return <LowPriority />
        } else {
            return <DefaultPriority />
        }
    }

    //HANDLE VIEWING HISTORY
    const handleViewHistory = () => {
        setViewHistory((prev) => !prev)
        if (!viewHistory) {
            getOnboardHistory();
        }
    }

    //HANDLE REFRESHING DOWNLINK QUEUE
    const handleRefresh = () => {
        if (isReadOnlyActions) return;
        if (!isRefreshIconEnable) return;
        setTypeOfAction('discard')
        setActionFileId({ status: '', fileId: truetwin_id })
    }

    useEffect(() => {
        const update = () => {
            if (!downlinkRefreshTime) {
                setTimeAgo('');
                return;
            }

            const current = dayjs(downlinkRefreshTime).fromNow();
            setTimeAgo(current);
        };

        update(); // initial call
        const interval = setInterval(update, 60000); // update every minute

        return () => clearInterval(interval);
    }, [downlinkRefreshTime]);

    const STATUS_COMPONENTS = {
        download_inprogress: (progress: number) => <OngoingProgress progress={progress} />,
        Error: (progress: number) => <ErrorProgress progress={progress} />,
        Unknown: (progress: number) => <UnknownProgress progress={progress} />,
        download_suspend: (progress: number) => <PauseProgress progress={progress} />,
    };

    return (
        <div className='downlink-queue-container'>

            {/* QUEUE HEADER */}
            <div className="downlink-queue-header">
                {/* History Button */}
                <div
                    className={`downlink-queue-history-button ${viewHistory ? "historyView" : ""}`}
                    onClick={handleViewHistory}
                >
                    View History
                    {viewHistory && <HistoryCrossButton />}
                </div>

                {/* Refresh Section */}
                <div className={`downlink-queue-refresh-container ${viewHistory ? "d-none" : ""}`}>
                    {isRefreshTimeLoading ? (
                        <AngularLoadingSpinner />
                    ) : (
                        <span className="downlink-queue-refresh-message">
                            {timeAgo && `Last updated ${timeAgo}`}
                        </span>
                    )}

                    {/* Info Tooltip */}
                    <div
                        id="refresh-info-div"
                        className={`refresh-info-card ${hover ? "active" : ""} ${isRefreshIconEnable ? 'small' : ''}`}
                        style={{
                            top: tab_name === 'files-ground-files' ? '5px' : '75px'
                        }}
                    >
                        <div className="refresh-info-card-text">
                            {isRefreshIconEnable
                                ? "Refresh Status"
                                : "Status can be refreshed only when in contact"}
                        </div>
                    </div>

                    {/* Refresh Icon */}
                    <div
                        className={`downlink-queue-refresh-icon ${isRefreshIconEnable ? "" : "disabled"} ${isReadOnlyActions ? "disabled" : ""}`}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={handleRefresh}
                    >
                        <RefreshButton />
                    </div>
                </div>
            </div>

            {/* QUEUE BODY */}
            {isDownlinkqueueLoading && <ShimmerMenuList rowHeight={58} reducedRows={2} />}
            {!isDownlinkqueueLoading &&
                <div
                    className={`flex-column gap-2 ${viewHistory ? ' d-none' : 'd-flex'}`}
                    style={{ height: 'calc(100vh - 230px)' }}
                >
                    {/* ONGOING DOWNLOAD BODY */}
                    <div className="queue-body-ongoing">
                        <div className={`queue-planned-rows-body`}>
                            {(["immediate", "high", "default", "low"] as const).map((priority) =>
                                categorizedFiles.downloading[priority].map((file) => (
                                    <div
                                        className={`queue-body-row ${file?.status === "download_inprogress" ? "active" : file?.status}`}
                                        key={file.uniqueId}
                                    >
                                        {/* ==== Left Section (File Info + Status Icon) ==== */}
                                        <div className="queue-body-row-left-section">
                                            {/* Status Icon (spinner for ongoing, else specific SVGs) */}
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '20px', width: '20px' }}>
                                                {file?.status === "download_inprogress" ? (
                                                    <AngularLoadingSpinner />
                                                ) : file?.status === "Error" ? (
                                                    <ErrorSvg />
                                                ) : file?.status === "Unknown" ? (
                                                    <UnknownSvg />
                                                ) : file?.status === "download_suspend" ? (
                                                    <PauseSvg />
                                                ) : (
                                                    ""
                                                )}
                                            </div>

                                            {/* File details: name, priority, size, location (hidden) */}
                                            <div className="name-date-container">
                                                <span
                                                    className="file-name-in-queue d-block text-truncate"
                                                    title={file?.fileName}
                                                >
                                                    {file?.fileName}
                                                </span>
                                                <span className="file-date-in-queue-ongoing">
                                                    <span className="priority-block">{priorityIcon(file?.filePriority)}</span> {/* Priority Icon */}
                                                    <span className="location-block d-none">Dubai, UAE</span> {/* Location (currently hidden) */}
                                                    <span className="size-block">{formatFileSize(file?.fileSize)}</span>{/* File Size */}
                                                </span>
                                            </div>
                                        </div>

                                        {/* ==== Right Section (Progress + Action Buttons) ==== */}
                                        <div className="queue-body-row-right-section">
                                            {/* Progress (depends on status) */}
                                            <div className="circular__progress__groundfiles">
                                                {STATUS_COMPONENTS[file?.status]?.(file?.progress) || ""}
                                            </div>

                                            {/* Action Button (Three Dots menu) */}
                                            <div
                                                className="right-buttons-container-ongoing cursor-pointer"
                                                style={{ visibility: file?.status === "download_inprogress" ? 'hidden' : 'visible' }}
                                                onClick={(e) => {
                                                    handleThreeDotsMenu(e, file, "ongoing");
                                                }}
                                            >
                                                {((!file?.status || file?.status === '') || (file?.status !== 'download_pending' && file?.status !== 'download_inprogress' && file?.status !== 'download_success' && file?.status !== 'download_cancel'))
                                                    ? ''
                                                    : <span className={isReadOnlyActions ? 'opacity-50' : ''}><ThreeDotsSvg /></span>}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}

                            {/* THREE DOTS MENU */}
                            <div
                                ref={(el) => {
                                    if (openThreeDots) {
                                        menuRefs.current[openThreeDots?.uniqueId] = el;
                                    }
                                }}
                                className={`three-dots-menu ${!isReadOnlyActions && ["download_inprogress", "download_suspend"].includes(openThreeDots?.status) ? "active" : ""}`}
                                style={{ width: "82px", top: menuPosition.top, left: menuPosition.left }}
                            >
                                {/* ------Needed for the future use------ */}
                                {/* Cancel option: shown for both 'download_inprogress' and 'Pause' */}
                                {/* {["download_inprogress", "download_suspend"].includes(openThreeDots?.status) && (
                                <span
                                    role="button"
                                    className="three-dots-menu-options"
                                    onClick={() => handleCancel(openThreeDots)}
                                >
                                    <span className="ms-2">Cancel</span>
                                </span>
                            )} */}

                                {/* Pause option: shown only when status is 'download_inprogress' */}
                                {/* {openThreeDots?.status === "download_inprogress" && (
                                <span
                                    role="button"
                                    className="three-dots-menu-options"
                                    onClick={() => handlePause(openThreeDots)}
                                >
                                    <span className="ms-2">Pause</span>
                                </span>
                            )} */}

                                {/* Resume option: shown only when status is 'Pause' */}
                                {/* {openThreeDots?.status === "download_suspend" && (
                                <span
                                    role="button"
                                    className="three-dots-menu-options"
                                    onClick={() => handleResume(openThreeDots)}
                                >
                                    <span className="ms-2">Resume</span>
                                </span>
                            )} */}
                            </div>
                        </div>
                    </div>

                    {/* PLANNED DOWNLOAD BODY */}
                    <div className="queue-body-planned">
                        <div className={`queue-planned-rows-body`}>
                            {(["immediate", "high", "default", "low"] as const).map((priority) =>
                                categorizedFiles.planned[priority].map((file) => (
                                    <div className="queue-body-row" key={file?.uniqueId}>
                                        {/* === Left section: Status icon + file info === */}
                                        <div className="queue-body-row-left-section">
                                            {/* Status icon */}
                                            <div className="d-flex justify-content-center align-items-center">
                                                <PendingSvg />
                                            </div>

                                            {/* File information */}
                                            <div className="name-date-container">
                                                <span
                                                    className="file-name-in-queue d-block text-truncate"
                                                    title={file?.fileName}
                                                >
                                                    {file?.fileName}
                                                </span>

                                                {/* File details: priority, location, size, upload info */}
                                                <span className="file-date-in-queue-ongoing">
                                                    <span className="priority-block">{priorityIcon(file?.filePriority)}</span>
                                                    <span className="location-block d-none">Dubai, UAE</span>
                                                    <span className="size-block">{formatFileSize(file?.fileSize)}</span>
                                                    <span className="file-date-in-queue d-none">Upload Starts in 36 Hours</span>
                                                </span>
                                            </div>
                                        </div>

                                        {/* === Right section: Three dots menu === */}
                                        <div className="queue-body-row-right-section">
                                            <div
                                                className="right-buttons-container-planned cursor-pointer"
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent parent click handlers
                                                    handleThreeDotsMenu(e, file, "plan");
                                                }}
                                            >
                                                {(file?.fileSize === 0 || !file?.fileSize || !file?.status || file?.status === '') ? '' : <ThreeDotsSvg />}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}


                            {/* THREE DOTS MENU -> PLAN SECTION */}
                            <div
                                ref={(el) => {
                                    if (openThreeDots) {
                                        menuRefs.current[openThreeDots?.uniqueId] = el;
                                    }
                                }}
                                className={`three-dots-menu ${!isReadOnlyActions && openThreeDots?.status === "download_pending" ? "active" : ""} ps-0`}
                                style={{ width: "126px", top: menuPosition.top, left: menuPosition.left }}
                            >
                                {openThreeDots?.status === "download_pending" && (
                                    <div role="button" className="three-dots-menu-options">
                                        <PriorityModal
                                            side="down"
                                            currentPriority={
                                                openThreeDots?.filePriority === "FILE_DL_PRIORITY_LOW"
                                                    ? "Low"
                                                    : openThreeDots?.filePriority === "FILE_DL_PRIORITY_NORMAL"
                                                        ? "Default"
                                                        : openThreeDots?.filePriority === "FILE_DL_PRIORITY_HIGH"
                                                            ? "High"
                                                            : openThreeDots?.filePriority === "FILE_DL_PRIORITY_IMMEDIATE"
                                                                ? "Immediate"
                                                                : "Default"
                                            }
                                            rowMenuOpen={openThreeDots}
                                            setRowMenuOpen={setOpenThreeDots}
                                            setTypeOfAction={setTypeOfAction}
                                            setActionFileId={setActionFileId}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }

            {/* HISTORY SECTION */}
            {!isDownlinkqueueLoading &&
                <div className={`flex-column gap-2 ${viewHistory ? ' d-flex' : 'd-none'}`} style={{ height: 'calc(100vh - 230px)' }}>
                    <div className="history_body h-100">
                        {downlinkHistoryFiles &&
                            Array.from(downlinkHistoryFiles.entries()).map(([dateLabel, files]) => {
                                return (
                                    <>
                                        <div className="history_day_indicator">{dateLabel}</div>
                                        {files.map((file: any) => (
                                            <div key={file?.uniqueId} className={`history_file_row ${true ? "active" : ""}`}>
                                                <div className="history_file_row_left_container">
                                                    {/* FILE ICON */}
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        {file?.status === "download_success" && <OnboardCompleteStatus />}
                                                        {file?.status === "Partial" && <PartialSvg />}
                                                    </div>

                                                    {/* FILE INFO */}
                                                    <div className="history_file_row_info_container">
                                                        <span
                                                            className="history_file_row_fileName d-block text-truncate"
                                                            title={file?.fileName}
                                                        >
                                                            {file?.fileName}
                                                        </span>

                                                        <span className="history_file_row_bottom_bar">
                                                            <span className="blocks">{file?.radioId === 'S-Band' ? 'S' : file?.radioId === 'X-Band' ? 'X' : 'UHF'}</span>
                                                            <span className="blocks">{formatFileSize(file?.fileSize)}</span>
                                                            <span className="blocks">{file?.appSrc}</span>
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* FILE EPOCH TIME */}
                                                <div className="history_file_row_right_container flex-column">
                                                    {file?.updatedAt
                                                        ? dayjs(file?.updatedAt).utc().format('HH:mm:ss [UTC]')
                                                        : '—'}
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )
                            })
                        }
                        {!downlinkHistoryFiles && <div className="no-files-text">No history found</div>}
                    </div>
                </div>
            }
        </div>
    )
}
export default DownlinkQueue;